module.exports = __webpack_public_path__ + "static/media/aragon79.fe06e538.jpg";